import api from "@/lib/api";

export function superHeaders() {
  const token = localStorage.getItem("super_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const superApi = {
  get: (url, config = {}) => api.get(url, { ...config, headers: { ...superHeaders(), ...config.headers } }),
  post: (url, body, config = {}) => api.post(url, body, { ...config, headers: { ...superHeaders(), ...config.headers } }),
  put: (url, body, config = {}) => api.put(url, body, { ...config, headers: { ...superHeaders(), ...config.headers } }),
};

export const PLANS = [
  {
    id: "basico",
    name: "Plan Básico",
    tagline: "Presencia Digital",
    branches: "1 matriz",
    branchAdmins: "No",
    attendance: "No",
    payments: "No",
    backup: "Mensual",
  },
  {
    id: "pro",
    name: "Plan Pro",
    tagline: "Control y Sucursales",
    branches: "Hasta 3",
    branchAdmins: "Sí",
    attendance: "Sí",
    payments: "No",
    backup: "Quincenal",
  },
  {
    id: "elite",
    name: "Plan Elite",
    tagline: "Corporativo / Franquicia",
    branches: "Ilimitadas",
    branchAdmins: "Sí",
    attendance: "Sí",
    payments: "Sí",
    backup: "24/7",
  },
];
